import ApiaField from '../ApiaField';
import ApiaForm from '../ApiaForm';
import Field from '../constants/Field';
import { IApiaField } from '../types';

export type TCaptchaField = IApiaField;

export default class CaptchaField extends ApiaField implements TCaptchaField {
  constructor(field: HTMLDivElement, form: ApiaForm) {
    super(field, form, [Field.PROPERTY_VISIBILITY_HIDDEN]);
  }
}
